import { Component } from '@angular/core';

@Component({
  selector: 'app-init-error',
  standalone: true,
  imports: [],
  templateUrl: './init-error.component.html',
  styleUrl: './init-error.component.scss'
})
export class InitErrorComponent {
  /**
   *
   */
  constructor() {
    document.getElementById("loading-screen")?.remove();
  }

  reload(): void {
    window.location.href = '/';
  }
}
